import { render, staticRenderFns } from "./teeth.vue?vue&type=template&id=69f2fbb2&scoped=true"
import script from "./teeth.vue?vue&type=script&lang=js"
export * from "./teeth.vue?vue&type=script&lang=js"
import style0 from "./teeth.vue?vue&type=style&index=0&id=69f2fbb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f2fbb2",
  null
  
)

export default component.exports